import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Report } from 'powerbi-report-component';
import { Container, Row } from 'react-bootstrap'
import "./Report.css";

class ReportView extends Component {

	 // lijst van geopende report views, zodat alleen de laatste reportview is die de token blijft verversen
	static reportViews = [];

	// constantes voor wanneer de token ververst moet worden
	static TokenValidityDurationInMs     = 60 * 60 * 1000;
	static TokenRefreshMarginInMs        =  5 * 60 * 1000;
	static TokenCheckRefreshIntervalInMs = 1 * 60 * 1000;
	
	constructor(props) {
		super(props);
		// handle van het powerbi report
		this.report = null;
		this.actionId = null;
		this.updateTokenInterval = null;
		this.componentGracefulUnmountCall = this.componentGracefulUnmount.bind(this);
		this.loadTimeStart = null;
		this.currentPageTitle = null;

		// bepaal wanneer token verloopt
		this.accessTokenExpiration = Date.now() + ReportView.TokenValidityDurationInMs;

		// stop vorige reports met ophalen van nieuwe tokens
		ReportView.reportViews.forEach(item => {
			item.componentGracefulUnmount();
		})

		// voeg het huigdige rapport toe zodat dit raport stopt met het ophalen van tokens
		ReportView.reportViews.push(this);

		this.currentTheme = "default";
	}

	getActionId = async () => {
		if (this.actionId != null) {
			return this.actionId;
        }
		// bepaal action id
		var urlParts = window.location.href.split("/")
		this.actionId = urlParts[urlParts.length - 1];
		if (this.actionId == "") {
			//this.actionId = 0; // TODO: uitzoeken hoe default pagina mee te geven?
			const response = await fetch('/account/me');
			if (response.ok) {
				const me = await response.json();
				this.actionId = me.defaultActionId;
			}
		}
		return this.actionId;
	}

	applyTheme(newTheme) {
		if (this.report == null) {
			return;
		}
		if (this.props.themaInstelbaar.toLowerCase() == "nee") {
			// thema niet instelbaar; gebruik het meegeleverde thema
			return;
		}
		if (this.currentTheme == newTheme) {
			return;
		}
		this.currentTheme = newTheme;
		var jsonTheme = "";
		for (const themeOption of this.props.themeOptions) {
			if (themeOption.name == this.currentTheme) {
				jsonTheme = themeOption.jsonTheme;
			}
		}
		this.report.applyTheme({ themeJson: JSON.parse(jsonTheme) });
	}

	// will be called when report loads
	handleReportLoad = (report) => {
		// sla de handle naar het rapport op
		this.report = report;

		this.applyTheme(this.props.theme);

		// controleer na het tijdsinterval of er een nieuwe access token moet worden opgehaald
		this.updateTokenInterval = setInterval(this.updateToken.bind(this), ReportView.TokenCheckRefreshIntervalInMs);

		// achtervang voor het stoppen van ophalen van tokens
		window.addEventListener('beforeunload', this.componentGracefulUnmountCall);
	}

	componentGracefulUnmount() {
		// stop met het ophalen van tokens
		if (this.updateTokenInterval != null) {
			clearInterval(this.updateTokenInterval);
			window.removeEventListener('beforeunload', this.componentGracefulUnmountCall);
			this.updateTokenInterval = null;
		}
	}

	async updateToken() {
		const currentTime = Date.now();
		const timeUntilExpiration = this.accessTokenExpiration - currentTime;

		// update alleen het token wanneer deze bijna verloopt
		if (timeUntilExpiration <= ReportView.TokenRefreshMarginInMs) {
			// gebruik het action id zodat extra poperties van het rapport (die in de database staan), ook worden meegenomen
			// bij het verversen van de embed token.
			const actionId = await this.getActionId();
			const url = 'api/PowerBIAccessToken/RefreshEmbedTokenForAction/' + actionId + '/';
			const response = await fetch(url);
			if (response.ok) {
				// lees token uit
				const embedToken = await response.json();

				// bepaal wanneer het nieuwe token verloopt
				this.accessTokenExpiration = currentTime + ReportView.TokenValidityDurationInMs;

				// Stel het nieuwe token in
				await this.report.setAccessToken(embedToken.embedToken);
			}
		}
    }

	handleDataSelected = async (data) => {
		this.loadTimeStart = performance.now();
		console.log("DataSelected report: " + data.report.displayName + "  page: " + data.page.displayName + " ");
		this.currentPageTitle = data.page.displayName;
		const actionId = await this.getActionId();
		const url = 'api/Report/LogDataSelected/' + actionId + '/';
		let postData = { Page: data.page.displayName };
		fetch(url, { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(postData) })
			.then(response => {
				if (response.ok) {
					console.log(response);
				}
			}
		);
	}

	handlePageChange = async (data) => {
		this.loadTimeStart = performance.now();
		console.log("PageChange page: " + data.newPage.displayName);
		this.currentPageTitle = data.newPage.displayName;
		const actionId = await this.getActionId();
		const url = 'api/Report/LogPageChange/' + actionId + '/';
		let postData = { Page: data.newPage.displayName };
		fetch(url, { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(postData) })
			.then(response => {
				if (response.ok) {
					console.log(response);
				}
			}
			);
	}

	handleRendered = async (data) => {
		if (this.loadTimeStart == null) { // alleen loadtime teruggeven als er nieuwe data is opgevraagd, niet als bijv een slicer is re-rendered
			return;
		}

		const loadTimeInMs = (performance.now() - this.loadTimeStart).toFixed(0);
		this.loadTimeStart = null;
		console.log("Rendered data in : " + loadTimeInMs + " ms");
		const actionId = await this.getActionId();
		const url = 'api/Report/LogPageLoaded/' + actionId;
		let postData = { Page: this.currentPageTitle, LoadTimeInMs: loadTimeInMs };
		fetch(url, { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(postData) })
			.then(response => {
				if (response.ok) {
					console.log(response);
				}
			}
		);
	}

	handleButtonClicked = async (data) => {
		//console.log("Button clicked");
    }

	handleTileClicked = (dashboard, data) => { // only used when embedType is "dashboard"
		// will be called when report loads
		//console.log("Tile clicked");

		this.report = dashboard; // get the object from callback and store it.(optional)
	}

	async componentDidMount() {
		document.body.className = "has-fullscreen";
	}

	async componentWillUnmount() {
		document.body.className = "";
		this.componentGracefulUnmount();
	}

	render() {

		//console.log(this.props);
		this.applyTheme(this.props.theme);

		var defaultLocaleSettings = {
			language: "nl",
			formatLocale: "nl-NL"
		};

		if (this.props.config.reportSettings.localeSettings) {
			defaultLocaleSettings = this.props.config.reportSettings.localeSettings;
		}

		let extraSettings = {
			navContentPaneEnabled: true, //true
			hideErrors: false, // Use this *only* when you want to override error experience i.e, use onError
			localeSettings: defaultLocaleSettings,
			panes: {
				pageNavigation: {
					visible: true,
					position: 0
				},
			},
		};
		switch (this.props.filterPane.toLowerCase()) {
			case "uitgeklapt":
				extraSettings.panes.filters = { visible: true, expanded: true }
				break;
			case "ingeklapt":
				extraSettings.panes.filters = { visible: true, expanded: false }
				break;
			case "verborgen":
			default:
				extraSettings.panes.filters = { visible: false }
		}

		// https://docs.microsoft.com/en-us/javascript/api/powerbi/powerbi-models/pagenavigationposition
		if (this.props.navigationPosition == "Left") {
			extraSettings.panes.pageNavigation.position = 1;
		} else if (this.props.navigationPosition == "Bottom") {
			extraSettings.panes.pageNavigation.position = 0;
		} else {
			// default bottom?
			extraSettings.panes.pageNavigation.position = 0;
		}


		let extraSettingsMerged = {
			...extraSettings,
			...this.props.config.reportSettings
		};

		var otapTypeClass = "report-wrapper-" + this.props.otapType;

		return (
			<Container fluid className={`report-wrapper ${otapTypeClass}`}>
				<Row className="report-wrapper-header report-wrapper-ONTW-header"> ONTWIKKEL </Row>
				<Row className="report-wrapper-header report-wrapper-TEST-header"> TEST </Row>
				<Row className="report-wrapper-header report-wrapper-ACPT-header"> ACCEPTATIE </Row>
				<Row className="report-wrapper-content-row">
					<Report
						embedType="report" // "dashboard"
						tokenType="Embed" // "Aad"
						reportMode="View"
						accessToken={this.props.embedToken}
						embedUrl={this.props.embedUrl}
						embedId={this.props.reportId} // report or dashboard Id goes here
						permissions="All" // View
						onLoad={this.handleReportLoad.bind(this)}
						onSelectData={this.handleDataSelected.bind(this)}
						onPageChange={this.handlePageChange.bind(this)}
						onTileClicked={this.handleTileClicked.bind(this)}
						onButtonClicked={this.handleButtonClicked.bind(this)}
						onRender={this.handleRendered.bind(this)}
						extraSettings={extraSettingsMerged}
					/>
				</Row>
			</Container>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		...state.account,
		...state.action.actionData,
		...state.theme,
	};
};

export default connect(
	mapStateToProps,
	dispatch => bindActionCreators({}, dispatch)
)(ReportView);



// WEBPACK FOOTER //
// ./src/components/Reports/ReportView.js